import { render, staticRenderFns } from "./DeleteBackupButton.vue?vue&type=template&id=c2f1a5f4&scoped=true&"
import script from "./DeleteBackupButton.vue?vue&type=script&lang=ts&"
export * from "./DeleteBackupButton.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteBackupButton.vue?vue&type=style&index=0&id=c2f1a5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f1a5f4",
  null
  
)

export default component.exports